import {Component} from '@angular/core';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {MatDialogRef} from "@angular/material/dialog";
import {MaintenanceOptions} from "./options/maintenance.options";

@Component({
  selector: 'app-maintenance',
  standalone: false,
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent {
  public static URL?: string;
  maintenanceOptions = new MaintenanceOptions();

  constructor(private http: HttpClient, private matDialogRef: MatDialogRef<MaintenanceComponent>) {
    this.matDialogRef.disableClose = true;
    let interval: any = setInterval(() => {
      http.get(MaintenanceComponent.URL!.split('/api/')[0] + '/ready-health', {observe: 'events'}).subscribe((response) => {
        if (response instanceof HttpResponse) {
          clearInterval(interval);
          window.location.reload();
          this.maintenanceOptions.onResolved();
          matDialogRef.close();
        }
      });
    }, 5 * 1000);
  }
}
